import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { UserAddOutlined } from '@ant-design/icons'
import AlertComponent from '@BUP/components/Generics/Alert'
import ButtonComponent from '@BUP/components/Generics/Buttons/button-component'
import ModalComponent from '@BUP/components/Generics/Modal'
import AddUsersForm from '@BUP/components/MySchool/addUsersForm'
import { useCreateEnrollment } from '@BUP/hooks/user/useCreateEnrollment'
import { useCreateRegistration } from '@BUP/hooks/registration/useCreateRegistration'
import styles from './add-student-button.module.scss'

const AddStudentButton = ({
  selectedCourse,
  getUsersList,
  getRegistrations,
  isActiveSurvey
}) => {
  const [t] = useTranslation()
  const [isOpenModal, setIsOpenModal] = useState(false)
  const { createEnrollment, loading, error, setError } =
    useCreateEnrollment(getUsersList)

  const handleCloseModal = () => {
    setError(null)
    setIsOpenModal(false)
  }

  const { createRegistration, loadingRegistration } = useCreateRegistration()

  const handleCreateEnrollment = async formValues => {
    const enrollment = await createEnrollment(formValues)
    if (enrollment) {
      const registration = await createRegistration(enrollment.id, selectedCourse)
      if (registration) {
        setIsOpenModal(false)
        getUsersList()
        getRegistrations()
      }
    }
  }

  let alert = null

  let handleClickButton = () => {
    setIsOpenModal(true)
  }

  if (isActiveSurvey) {
    alert = (
      <AlertComponent
        type='info'
        message={t('pages.MySchool.alertText.activationText')}
      />
    )
    handleClickButton = null
  }

  return (
    <div className={styles.button_wrapper}>
      {alert}
      <ButtonComponent
        colorType='secondary'
        buttonText={<UserAddOutlined className={styles.icon} />}
        onClick={handleClickButton}
        disabled={isActiveSurvey}
      />
      <ModalComponent
        header
        headerText={t('common.resources.user.actions.add.submit')}
        modalDescription={
          <AddUsersForm
            selectedCourse={selectedCourse}
            error={error}
            roleType='student'
            createEnrollment={handleCreateEnrollment}
            loading={loading}
            loadingRegistration={loadingRegistration}
          />
        }
        stateModal={isOpenModal}
        showButtons={false}
        onClickCloseModal={handleCloseModal}
      />
    </div>
  )
}

export default AddStudentButton
